/* eslint-disable sort-keys */
import { PARSAction } from 'core/models';
import {
  IClientCredential,
  IClientCredentialsPaginated,
  ICreateClientCredentialResponse,
  IRotateClientSecretResponse,
} from 'core/clientCredentialsApiService';
import {
  CREATE_CLIENT_CREDENTIAL,
  CREATE_CLIENT_CREDENTIAL_SUCCESS,
  CREATE_CLIENT_CREDENTIAL_FAILURE,
  DELETE_CLIENT_CREDENTIAL,
  DELETE_CLIENT_CREDENTIAL_SUCCESS,
  DELETE_CLIENT_CREDENTIAL_FAILURE,
  ROTATE_CLIENT_SECRET,
  ROTATE_CLIENT_SECRET_SUCCESS,
  ROTATE_CLIENT_SECRET_FAILURE,
  GET_CLIENT_CREDENTIALS_SUCCESS,
  GET_CLIENT_CREDENTIALS_FAILURE,
  GET_CLIENT_CREDENTIALS,
  CLEAR_SECRET_DATA,
} from './types';

export interface ClientCredentialsState {
  credentials: IClientCredentialsPaginated | null;
  currentCredential: IClientCredential | null;
  newlyCreatedCredential: ICreateClientCredentialResponse | null;
  rotatedCredential: IRotateClientSecretResponse | null;
  loading: boolean;
  error: Error | null;
}

const initialState: ClientCredentialsState = {
  credentials: null,
  currentCredential: null,
  newlyCreatedCredential: null,
  rotatedCredential: null,
  loading: false,
  error: null,
};

export const clientCredentialsReducer = (
  state = initialState,
  action: PARSAction<any, string>,
): ClientCredentialsState => {
  switch (action.type) {
    // Loading states
    case CREATE_CLIENT_CREDENTIAL:
    case DELETE_CLIENT_CREDENTIAL:
    case ROTATE_CLIENT_SECRET:
    case GET_CLIENT_CREDENTIALS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    // Get client credentials success
    case GET_CLIENT_CREDENTIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        credentials: action.payload,
      };

    // Create client credential success
    case CREATE_CLIENT_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        newlyCreatedCredential: action.payload,
      };

    // Delete client credential success
    case DELETE_CLIENT_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        credentials: state.credentials
          ? {
              ...state.credentials,
              Data: state.credentials.Data.filter((cred) => cred.id !== action.payload),
            }
          : null,
      };

    // Rotate client secret success
    case ROTATE_CLIENT_SECRET_SUCCESS:
      return {
        ...state,
        loading: false,
        rotatedCredential: action.payload,
      };

    // Error states
    case CREATE_CLIENT_CREDENTIAL_FAILURE:
    case DELETE_CLIENT_CREDENTIAL_FAILURE:
    case ROTATE_CLIENT_SECRET_FAILURE:
    case GET_CLIENT_CREDENTIALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Clear secret data
    case CLEAR_SECRET_DATA:
      return {
        ...state,
        newlyCreatedCredential: null,
        rotatedCredential: null,
      };

    default:
      return state;
  }
};

export default clientCredentialsReducer;
